import { render, staticRenderFns } from "./index old.vue?vue&type=template&id=752bcf30&scoped=true&"
import script from "./index old.vue?vue&type=script&lang=js&"
export * from "./index old.vue?vue&type=script&lang=js&"
import style0 from "./index old.vue?vue&type=style&index=0&id=752bcf30&lang=scss&scoped=true&"
import style1 from "./index old.vue?vue&type=style&index=1&id=752bcf30&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style2 from "./index old.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752bcf30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752bcf30')) {
      api.createRecord('752bcf30', component.options)
    } else {
      api.reload('752bcf30', component.options)
    }
    module.hot.accept("./index old.vue?vue&type=template&id=752bcf30&scoped=true&", function () {
      api.rerender('752bcf30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/zhlg/index old.vue"
export default component.exports